import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Video as VideoIcon } from "lucide-react";
import { api } from "@/lib/api";
import { COMMUNITY_VIDEO_MODAL } from "@/constants/testIds";

export const CommunityVideoModal = ({ open, onOpenChange, onUploaded }) => {
  const [petName, setPetName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [mobile, setMobile] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!ownerName.trim() || mobile.trim().length < 8) {
      toast.error("Name and mobile number are necessary before uploading.");
      return;
    }
    if (!petName.trim()) {
      toast.error("Please enter your pet's name.");
      return;
    }
    if (!file) {
      toast.error("Please select a video of your dog.");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("pet_name", petName);
    formData.append("owner_name", ownerName);
    formData.append("mobile", mobile);
    formData.append("file", file);
    try {
      await api.post("/community-videos", formData, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Thank you! Your dog's video has been shared.");
      setPetName("");
      setOwnerName("");
      setMobile("");
      setFile(null);
      onOpenChange(false);
      onUploaded?.();
    } catch {
      toast.error("Upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={COMMUNITY_VIDEO_MODAL.dialog} className="max-w-md rounded-[2rem]">
        <DialogHeader>
          <VideoIcon className="w-8 h-8 text-[#D97736] mb-2" />
          <DialogTitle className="font-display text-2xl font-bold text-[#0F2520]">
            Share Your Dog's Video
          </DialogTitle>
          <DialogDescription className="font-light text-[#0F2520]/70">
            Name &amp; mobile number are necessary before uploading.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <Input
            data-testid={COMMUNITY_VIDEO_MODAL.petNameInput}
            placeholder="Your Pet's Name"
            value={petName}
            onChange={(e) => setPetName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Input
            data-testid={COMMUNITY_VIDEO_MODAL.ownerNameInput}
            placeholder="Your Name"
            value={ownerName}
            onChange={(e) => setOwnerName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Input
            data-testid={COMMUNITY_VIDEO_MODAL.mobileInput}
            placeholder="Mobile Number"
            type="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            className="h-12 rounded-xl"
          />
          <input
            data-testid={COMMUNITY_VIDEO_MODAL.fileInput}
            type="file"
            accept="video/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="text-sm text-[#0F2520]/70 w-full"
          />
          <Button
            data-testid={COMMUNITY_VIDEO_MODAL.submitBtn}
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#D97736] hover:bg-[#0F2520] text-white font-semibold"
          >
            {loading ? "Uploading..." : "Upload Video"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
